module.exports = __webpack_public_path__ + "static/Ziegler_Card-6a637238074b38ac1494782373174a61.png";